import { LitElement, html, css } from 'lit'

export class BodyOverlay extends LitElement {
  static styles = [
    css`
      :host {
        display: block;
      }

      .overlay {
        background: #000000;
        opacity: 0.65;
        position: fixed;
        bottom: 0;
        left: 0;
        z-index: 1999;
        height: 100%;
        width: 100%;
      }

      .overlay[aria-hidden='true'] {
        display: none;
      }
    `,
  ]
  /**
   * @description Describes attributes on the element that act as inputs on this component
   * @prop {boolean}[hide=true] An attribute hides bodyOverlay or shows it depending on ts value. Defaults to hide bodyOverlay.
   * @prop {string} id - The id of the side drawer used by side-drawer-btn to toggle specific side drawer
   * @prop {string} [top='0px'] - ex. '100px' Moves the top of the side drawer down a certain amount of pixels
   * @prop {string} [topElement] - An element selector that moves the top of the side drawer down by the height of that element
   */
  static properties = {
    hide: { type: Boolean },
    top: { type: String },
    topElement: { type: String, attribute: 'top-element' },
    id: { type: String, reflect: true },
  }

  connectedCallback() {
    super.connectedCallback()
    this.hide = true
    this.closeEvent = null
    this.secondaryCloseEvent = null
    this.top = this.top ?? '0px'
    this.currentScrollPosition = null
    this.innerViewHeight = null
    this._toggle = (e) => {
      if (this.hide) {
        this.currentScrollPosition = document.documentElement.scrollTop || document.body.scrollTop
        this.innerViewHeight = window.innerHeight
      }
      this._setTop()
      this.hide = !this.hide
      if (e?.detail?.state && e.detail.state === 'open') {
        this.hide = false
      } else if (e?.detail?.state && e.detail.state === 'close') {
        this.hide = true
      }
      this._toggleBodyClass(this.hide)
      this.closeEvent = e.detail?.closeEvent
      this.secondaryCloseEvent = e.detail?.secondaryCloseEvent
    }

    //listen for bodyOverlay toggle event
    window.MicroBus.on(`${this.id}:toggle`, this._toggle)
  }

  disconnectedCallback() {
    super.connectedCallback()
    window.MicroBus.off(`${this.id}:toggle`, this._toggle)
  }

  render() {
    return html`
      <div class="overlay" aria-hidden=${this.hide} @click=${this._onclick} style="height: calc(100% - ${this.top});"></div>
    `
  }

  _onclick() {
    window.MicroBus.emit(this.closeEvent, { el: this.el })
    if (this.secondaryCloseEvent) window.MicroBus.emit(this.secondaryCloseEvent, { el: this.el })
  }

  _setTop() {
    if (this.topElement) {
      const el = document.querySelector(this.topElement)
      const height = el.offsetHeight
      this.top = height + 'px'
    }
  }

  _toggleBodyClass(hide) {
    var body = document.querySelector('body')
    if (!hide) {
      body.classList.add('overlay-active')
      //used for iOS safari position: fixed bug (where iOS safari adds extra space)
      document.documentElement.style.height = this.innerViewHeight + 'px'
    } else {
      body.classList.remove('overlay-active')
      document.documentElement.style.height = ''
      window.scrollTo(0, this.currentScrollPosition)
    }
  }
}
customElements.define('body-overlay', BodyOverlay)
